/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Stock_OutInputs */

const vi_notif_type_stock_out = /** @type {(inputs: Notif_Type_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất kho`)
};

/**

* @param {Notif_Type_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_stock_out = /** @type {((inputs?: Notif_Type_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_stock_out(inputs)
});